import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core";
import { Container, Row, Image, Form, Col, Table } from "react-bootstrap";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";



const UserFilters = ({ showFilter, selectedTab, onCancel, onSearch, innerTab, filterData, favPage, ...props }) => {


    const dinerFilter = {
        pax: [{ value: "ALL", name: 'All' },
        { value: "0-2", name: '0-2' },
        { value: "3-4", name: '3-4' },
        { value: "5-6", name: '5-6' },
        { value: "7-8", name: '7-8' },
        { value: "8+", name: '8+' }],
        status: [{ value: "PENDING", name: 'Pending' },
        { value: "NOTSEATED", name: 'Not Seated' },
        { value: "SEATED", name: 'Seated' },
        { value: "REJECTED", name: 'Rejected' },
        { value: "COMPLETED", name: 'Completed' },
        { value: "CANCELLED", name: 'Cancelled' }]
    }

 
    const orderFilter = {
        status: [
            { value: 0, name: 'PENDING' },
            { value: 1, name: 'CONFIRM' },
            { value: 2, name: 'PREPARING' },
            { value: 3, name: 'PACKING' },
            { value: 4, name: 'READYTOPICK' },
            { value: 5, name: 'ONTHEWAY' },
            { value: 6, name: 'DELIVERY' },
            { value: 7, name: 'COMPLETED' },
            { value: 8, name: 'CANCELLED' }
        ],
        paymentStatus: [
            { value: 0, name: 'PENDING' },
            { value: 1, name: 'COMPLETED' },
            { value: 2, name: 'CANCELLED' },
            { value: 3, name: 'FAILURE' }
        ],
        paymentType: [
            { value: 0, name: 'CASH' },
            { value: 1, name: 'UPI' },
            { value: 2, name: 'PAYTM' },
            { value: 3, name: 'DEBITCARD' },
            { value: 4, name: 'CREDITCARD' },
            { value: 5, name: 'NETBANKING' },
            { value: 6, name: 'PAYLATER' },
            { value: 7, name: 'WALLET' }
        ]
    }

    const ratingFilter = {
        value: [
            { value: 1, name: '1' },
            { value: 2, name: '2' },
            { value: 3, name: '3' },
            { value: 4, name: '4' },
            { value: 5, name: '5' }
        ],
        location: '',
        through: [
            { value: 0, name: "Takeaway" },
            { value: 1, name: "Curbside" },
            { value: 2, name: "Skip the Line" },
            { value: 3, name: "Dine-In" },
            { value: 4, name: "Buffet" },
            { value: 5, name: "Catering" },
            { value: 6, name: "Drivethru" },
            { value: 7, name: "Home Delivery" },
            { value: "SEATING", name: "Seating" },
            { value: "RESERVATION", name: 'Reservation' },
            { value: "SCAN_AND_PAY", name: "Scan & Pay" },
            { value: "WALLET", name: "Wallet" },
            { value: "Razorpay", name: "Razorpay" }
        ]
    }

    const nominationFilter = {
        value: ''
    }

    const eventFilter = {
        eventType: [{ value: "RSVP", name: "RSVP" }, { value: "TICKET_BOOKED", name: "TICKET BOOKING" }],
        status: [
            { value: "PENDING", name: "PENDING" },
            { value: "NOTSEATED", name: "NOTSEATED" },
            { value: "SEATED", name: "SEATED" },
            { value: "REJECTED", name: "REJECTED" },
            { value: "COMPLETED", name: "COMPLETED" },
            { value: "CANCELLED", name: "CANCELLED" }
        ]
    }

    const eventFilterFav = {
        eventType: [{ value: "online", name: "Online" }, { value: "offline", name: "Offline" }],
    }

    const resfavfilter = {
        status : [ 
            {value : "Favourite removed" ,name: "Favourite removed"},
            {value : "Favourite added" ,name: "Favourite added"}
        ]
    }

    const walletFilter = {
        captured: [{ value: false, name: "Pending/Failure" }, { value: true, name: "Success" }],
        wType: [
            { value: "card", name: "Card" },
            { value: "upi", name: "UPI" },
            { value: "wallet", name: "Wallet" },
            { value: "netbanking", name: "Net Banking" }
        ],
        tType: [{ value: "RAZORPAY", name: "Razorpay" }, { value: "WALLET", name: "Wallet" }, { value: "SCAN_AND_PAY", name: "Scan & Pay" }]
    }

    const referralFilter = {
        role: [{ value: 'user', name: 'User' }, { value: 'affiliates', name: 'Affiliates' }, { value: 'sale', name: 'Sale' }, { value: 'partner', name: 'Partner' }]
    }

    const miscFilter = {
        type: [{ value: 'viewed', name: 'Viewed' }, { value: 'used', name: 'Used/Availed' }]
    }

    const ticketFilter = {
        status: [
            { value: 0, name: "New" },
            { value: 1, name: "In-Progress" },
            { value: 2, name: "Awaiting Feedback" },
            { value: 3, name: "On Hold" },
            { value: 4, name: "Re-Opened" },
            { value: 5, name: "Resolved" },
            { value: 6, name: "Closed" },
            { value: 7, name: "Archive" },
            { value: 8, name: "Called User" },
            { value: 9, name: "Completed" }
        ],
        type: [
            { name: "Seating", value: "60378a476fd358ce05f0a015" },
            { name: "Ordering", value: "60363a2f164b288a603adc4f" },
            { name: "Scan & Pay", value: "6036560277d1eacb1e93c192" },
            { name: "Offers", value: "60364e47ee4004a8aaa7abb5" },
            { name: "Wallet", value: "603656b677d1eacb1e93c195" },
            { name: "Technical", value: "603657a977d1eacb1e93c19c" },
            { name: "Events", value: "6036580b77d1eacb1e93c19e" },
            { name: "Referral", value: "603659cc77d1eacb1e93c1a7" },
            { name: "Rating & Review", value: "6036588977d1eacb1e93c19f" },
            { name: "General/Other", value: "6036590e77d1eacb1e93c1a5" },
            { name: "Other/Payment", value: "6036597a77d1eacb1e93c1a6" }
        ]
    }

    const offerFilter = {
        type: [{ value: 'online', name: 'Online' }, { value: 'offline', name: 'Offline' }],
        disc: [{ value: 'value', name: 'Value' }, { value: 'percentage', name: 'Percentage' }]
    }





    const [diner, setDiner] = useState({ status: '', pax: '' });
    const [order, setOrder] = useState({ status: '', paymentType: '', paymentStatus: '' })
    const [event, setEvent] = useState({ eventType: '', status: '', paymentType: '', paymentStatus: '' })
    const [wallet, setWallet] = useState({ wType: '', captured: "", tType: "" })
    const [rating, setRating] = useState({ value: '' })
    const [referral, setReferral] = useState({ role: '' })
    const [misc, setMisc] = useState({ type: '' });
    const [ticket, setTicket] = useState({ status: '' });
    const [offer, setOffer] = useState({ type: '', disc: '',status :"" })
    const [nomination, setNomination] = useState({ value: '' })

    const onFilterSearch = () => {
        let filter = {};
        if (selectedTab === '1') {
            filter = diner;
            onSearch(filter);
        }
        if (selectedTab === '2') {
            filter = order;
            onSearch(filter);
        }
        if (selectedTab === '3') {
            filter = event;
            onSearch(filter);
        }
        if (selectedTab === '4') {
            filter = wallet;
            onSearch(filter);
        }
        if (selectedTab === '5') {
            filter = nomination;
            onSearch(filter);
        }
        if (selectedTab === '7') {
            filter = rating;
            onSearch(filter);
        }
        if (selectedTab === '8') {
            filter = referral;
            onSearch(filter);
        }
        if (selectedTab === '9') {
            filter = misc;
            onSearch(filter);
        }
        if (selectedTab === '10') {
            filter = ticket;
            onSearch(filter);
        }
        if (selectedTab === '13') {
            filter = offer;
            onSearch(filter);
        }
    }

    return (
        <>
            {showFilter && (
                <div
                    className="container-fluid p-4"
                    style={{ backgroundColor: "#ffffff" }}
                >
                    {(selectedTab === "1") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Total PAX
                                        </InputLabel>
                                        <Select
                                            value={diner?.pax}
                                            onChange={(e) => setDiner({ ...diner, pax: e.target.value })}
                                            label="Total PAX"
                                            inputProps={{
                                                name: "Total PAX",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {dinerFilter?.pax.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Status
                                        </InputLabel>
                                        <Select
                                            value={diner?.status}
                                            onChange={(e) => setDiner({ ...diner, status: e.target.value })}
                                            label="Status"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {dinerFilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                    {(selectedTab === "2") && (<Row>
                        <Col md={6}>
                            <Form.Group>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="outlined-pmethod">
                                        Payment Method
                                    </InputLabel>
                                    <Select
                                        value={order.paymentType}
                                        onChange={(e) => setOrder({ ...order, paymentType: e.target.value })}
                                        label="Payment Method"
                                        inputProps={{
                                            name: "pmethod",
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        {orderFilter.paymentType.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="outlined-Status">
                                        Status
                                    </InputLabel>
                                    <Select
                                        value={order.status}
                                        onChange={(e) => setOrder({ ...order, status: e.target.value })}
                                        label="Status"
                                        inputProps={{
                                            name: "Status",
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        {orderFilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="outlined-Pstatus">
                                        Payment Status
                                    </InputLabel>
                                    <Select
                                        value={order.paymentStatus}
                                        onChange={(e) => setOrder({ ...order, paymentStatus: e.target.value })}
                                        label="Payment Status"
                                        inputProps={{
                                            name: "Pstatus",
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        {orderFilter.paymentStatus.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>
                    </Row>)}
                    {(selectedTab === "3") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                          Ticket type
                                        </InputLabel>
                                        <Select
                                            value={event.eventType}
                                            onChange={(e) => setEvent({ ...event, eventType: e.target.value })}
                                            label="Event Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {eventFilter?.eventType.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                             Status
                                        </InputLabel>
                                        <Select
                                            value={event.status}
                                            onChange={(e) => setEvent({ ...event, status: e.target.value })}
                                            label="Event Status"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {eventFilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "4") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Payment Method
                                        </InputLabel>
                                        <Select
                                            value={wallet.wType}
                                            onChange={(e) => setWallet({ ...wallet, wType: e.target.value })}
                                            label="Payment Method"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {walletFilter?.wType.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Status
                                        </InputLabel>
                                        <Select
                                            value={wallet.captured}
                                            onChange={(e) => setWallet({ ...wallet, captured: e.target.value })}
                                            label="Status"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {walletFilter?.captured.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Transaction Type
                                        </InputLabel>
                                        <Select
                                            value={wallet.tType}
                                            onChange={(e) => setWallet({ ...wallet, tType: e.target.value })}
                                            label="Transaction Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {walletFilter?.tType.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "5") && (
                        <Row>
                            <Col md={6}>
                                <Form.Control
                                    type="text"
                                    placeholder="Location"
                                    value={nomination.value}
                                    onChange={(e) => setNomination({ ...nomination, value: e.target.value })}
                                    className="amSearch"
                                />
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "6") && (favPage === "1")  && (
                        <Row>
                            <Col md={6}>
                                <Form.Control
                                    type="text"
                                    placeholder="Location"
                                    value={offer.type}
                                    onChange={(e) => setOffer({ ...offer, type: e.target.value })}
                                    className="amSearch"
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            status
                                        </InputLabel>
                                        <Select
                                            value={offer.status}
                                            onChange={(e) => setOffer({ ...offer, status: e.target.value })}
                                            label="Payment Method"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {resfavfilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                        {(selectedTab === "6") && (favPage === "2")  && (
                        <Row>
                           <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                         offer   Type
                                        </InputLabel>
                                        <Select
                                            value={offer.type}
                                            onChange={(e) => setOffer({ ...offer, type: e.target.value })}
                                            label="Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {offerFilter?.type.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                           {(selectedTab === "6") && (favPage === "3")  && (
                        <Row>
                             <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                        Experience type
                                        </InputLabel>
                                        <Select
                                            value={event.eventType}
                                            onChange={(e) => setEvent({ ...event, eventType: e.target.value })}
                                            label="Event Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {eventFilterFav?.eventType.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                     {(selectedTab === "6") && (favPage === "4")  && (
                        <Row>
                        
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            status
                                        </InputLabel>
                                        <Select
                                            value={offer.status}
                                            onChange={(e) => setOffer({ ...offer, status: e.target.value })}
                                            label="Payment Method"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {resfavfilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "7") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Rating
                                        </InputLabel>
                                        <Select
                                            value={rating.value}
                                            onChange={(e) => setRating({ ...rating, value: e.target.value })}
                                            label="Rating"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {ratingFilter?.value.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Request Type
                                        </InputLabel>
                                        <Select
                                            value={rating.through}
                                            onChange={(e) => setRating({ ...rating, through: e.target.value })}
                                            label="Request Type"
                                            inputProps={{
                                                name: "through",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {ratingFilter?.through.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Control
                                    type="text"
                                    placeholder="Location"
                                    value={rating.location}
                                    onChange={(e) => setRating({ ...rating, location: e.target.value })}
                                    className="amSearch"
                                />
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "8") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Role
                                        </InputLabel>
                                        <Select
                                            value={referral.role}
                                            onChange={(e) => setReferral({ ...referral, role: e.target.value })}
                                            label="Role"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {referralFilter?.role.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "9") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Type
                                        </InputLabel>
                                        <Select
                                            value={misc.type}
                                            onChange={(e) => setMisc({ ...misc, type: e.target.value })}
                                            label="Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {miscFilter?.type.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "10") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Status
                                        </InputLabel>
                                        <Select
                                            value={ticket.status}
                                            onChange={(e) => setTicket({ ...ticket, status: e.target.value })}
                                            label="Status"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {ticketFilter?.status.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Issue Type
                                        </InputLabel>
                                        <Select
                                            value={ticket.type}
                                            onChange={(e) => setTicket({ ...ticket, type: e.target.value })}
                                            label="Issue Type"
                                            inputProps={{
                                                name: "type",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {ticketFilter?.type.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    {(selectedTab === "13") && (
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                         offer   Type
                                        </InputLabel>
                                        <Select
                                            value={offer.type}
                                            onChange={(e) => setOffer({ ...offer, type: e.target.value })}
                                            label="Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {offerFilter?.type.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <FormControl variant="outlined" className="w-100">
                                        <InputLabel htmlFor="outlined-Status">
                                            Discount Type
                                        </InputLabel>
                                        <Select
                                            value={offer.disc}
                                            onChange={(e) => setOffer({ ...offer, disc: e.target.value })}
                                            label="Discount Type"
                                            inputProps={{
                                                name: "Status",
                                            }}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            {offerFilter?.disc.map(ele => (<MenuItem value={ele.value} key={ele.value}>{ele.name}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    <div className="mt-5 d-flex">
                        <button
                            type="button"
                            className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                            title="Cancel Button"
                            onClick={onCancel}
                        >
                            Reset
                        </button>
                        <button
                            type="button"
                            className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                            title="Confirm Button"
                            onClick={onFilterSearch}
                        >
                            Apply Filter
                        </button>
                    </div>
                </div>
            )}
        </>)
}

export default UserFilters;